/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BrandAndMarket
 */
export interface BrandAndMarket {
    /**
     * 
     * @type {number}
     * @memberof BrandAndMarket
     */
    brand?: number;
    /**
     * 
     * @type {string}
     * @memberof BrandAndMarket
     */
    market?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BrandAndMarket
     */
    allowEdit?: boolean;
}

export function BrandAndMarketFromJSON(json: any): BrandAndMarket {
    return BrandAndMarketFromJSONTyped(json, false);
}

export function BrandAndMarketFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrandAndMarket {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brand': !exists(json, 'brand') ? undefined : json['brand'],
        'market': !exists(json, 'market') ? undefined : json['market'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
    };
}

export function BrandAndMarketToJSON(value?: BrandAndMarket | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brand': value.brand,
        'market': value.market,
        'allowEdit': value.allowEdit,
    };
}


